.root {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  font-size: 1.5rem;
  color: var(--on-background);
  background: transparent;
  border: none;

  @media (--sm-up) {
    font-size: 2rem;
  }

  @media (--md-up) {
    font-size: 2.5rem;
  }
}

.input.input {
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
  text-align: inherit;
  background: transparent;

  &:focus {
    color: inherit;
    color: var(--on-background);
    background-color: transparent;
  }

  :global(.was-validated) &:valid,
  &.is-valid {
    padding-right: 0.75rem; /* BS-default */
    background-image: none;
  }
}

.title {
  padding-top: 13px;
  margin-bottom: 21px;
  cursor: pointer;
}
